export default {
  10001: {
    appId: 10001,
    appStoreGameName: 'Word Crossy - A crossword game',
    developerName: 'WORD CALM',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/10001.webp'
  },
  100040: {
    appId: 100040,
    appStoreGameName: 'Word Crush - Fun Puzzle Game',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100040.webp'
  },
  100057: {
    appId: 100057,
    appStoreGameName: 'Word Calm - Scape puzzle game',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100057.webp'
  },
  100066: {
    appId: 100066,
    appStoreGameName: 'Wort Schau - Wörterspiel',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100066.webp'
  },
  100071: {
    appId: 100071,
    appStoreGameName: 'Word Buddies - Fun Puzzle Game',
    developerName: 'WORD CALM',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100071.jpg'
  },
  100074: {
    appId: 100074,
    appStoreGameName: 'Mergical',
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100074.webp'
  },
  100080: {
    appId: 100080,
    appStoreGameName: 'Tank Hero - Awesome tank war games',
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100080.webp'
  },
  100087: {
    appId: 100087,
    appStoreGameName: 'Solitaire Home Design',
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100087.webp'
  },
  100096: {
    appId: 100096,
    appStoreGameName: 'Word Slices',
    developerName: 'Word Crush',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100096.webp'
  },
  100098: {
    appId: 100098,
    appStoreGameName: 'Jackpotland-Vegas Casino Slots',
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100098.webp'
  },
  100100: {
    appId: 100100,
    appStoreGameName: 'Mots Malins - Jeu de mots pro',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100100.webp'
  },
  100114: {
    appId: 100114,
    appStoreGameName: 'たんクラ-単語クラッシュ：言葉消し単語パズルゲーム',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100114.webp'
  },
  100116: {
    appId: 100116,
    appStoreGameName: 'Dragon Farm Adventure-Fun Game',
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100116.webp'
  },
  100127: {
    appId: 100127,
    appStoreGameName: 'Tile Tap - Triple Match Game',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100127.webp'
  },
  100129: {
    appId: 100129,
    appStoreGameName: 'Block Guru - Wood Cube Game',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100129.webp'
  },
  100145: {
    appId: 100145,
    appStoreGameName: 'Gold Valley - Idle Lumber Inc',
    developerName: 'Funjoy',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100145.webp'
  },
  100172: {
    appId: 100172,
    appStoreGameName: '単語の達人',
    developerName: 'TangramGames',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100172.webp'
  },
  100182: {
    appId: 100182,
    appStoreGameName: 'LegendaryMonster',
    developerName: 'Funjoy',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100182.webp'
  },
  100190: {
    appId: 100190,
    appStoreGameName: 'Restaurant Allstar: Cook Dash',
    developerName: 'BETTA STUDIOS',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100190.webp'
  },
  100192: {
    appId: 100192,
    appStoreGameName: 'Fairyscapes Adventure',
    developerName: 'Funjoy',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100192.webp'
  },
  100198: {
    appId: 100198,
    appStoreGameName: 'Tiny Survivor',
    developerName: 'BETTA STUDIOS',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100198.webp'
  },
  100202: {
    appId: 100202,
    appStoreGameName: 'Parking Puzzle Quest',
    developerName: 'BETTA STUDIOS',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100202.webp'
  },
  100204: {
    appId: 100204,
    appStoreGameName: 'Block Champ - Brick Master',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100204.webp'
  },
  100208: {
    appId: 100208,
    appStoreGameName: 'Crazy SuperMarket',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100208.webp'
  },
  100210: {
    appId: 100210,
    appStoreGameName: 'Monster Legion',
    developerName: 'Funjoy',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100210.webp'
  },
  100214: {
    appId: 100214,
    appStoreGameName: 'Wort Sucht - Worträtselspiel',
    developerName: 'WORD CALM',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100214.webp'
  },
  100222: {
    appId: 100222,
    appStoreGameName: "Grimms' Tales：Mergical2",
    developerName: 'BETTA GAMES',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100222.webp'
  },
  100224: {
    appId: 100224,
    appStoreGameName: 'Food Sort Android',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100224.webp'
  },
  100225: {
    appId: 100225,
    appStoreGameName: 'Food Sort iOS',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100225.webp'
  },
  100226: {
    appId: 100226,
    appStoreGameName: 'Mahjong Tile 3D android',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100226.webp'
  },
  100227: {
    appId: 100227,
    appStoreGameName: 'Mahjong Tile 3D iOS',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100227.webp'
  },
  100228: {
    appId: 100228,
    appStoreGameName: 'Love Choice',
    developerName: 'Kiwishort.tv ',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100228.webp'
  },
  100229: {
    appId: 100229,
    appStoreGameName: 'Love Choice: the Dating Game',
    developerName: 'Tianjin Yuedong Technology Limited',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100229.webp'
  },
  100230: {
    appId: 100230,
    appStoreGameName: 'Joyful Droplet Android',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100230.webp'
  },
  100234: {
    appId: 100234,
    appStoreGameName: 'Word Search Tycoon:Seek & Find',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100234.webp'
  },
  100236: {
    appId: 100236,
    appStoreGameName: 'Word Vista',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100236.webp'
  },
  100238: {
    appId: 100238,
    appStoreGameName: 'Cryptogram Go',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100238.png'
  },
  100240: {
    appId: 100240,
    appStoreGameName: 'Love Choice JK',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100240.webp'
  },
  100246: {
    appId: 100246,
    appStoreGameName: 'Mergevia',
    developerName: 'Funjoy Technology Limited',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100246.png',
    gamePrivacyLink: 'https://fotoable.net/privacy',
    gameTermsLink: 'https://fotoable.net/terms'
  },
  100248: {
    appId: 100248,
    appStoreGameName: 'Jackpot Odyssey',
    developerName: 'AUTUMN STUDIOS LIMITED',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100248.png',
    gamePrivacyLink: 'https://fotoable.net/privacy',
    gameTermsLink: 'https://fotoable.net/terms'
  },
  100250: {
    appId: 100250,
    appStoreGameName: 'Word Crush Lite',
    developerName: 'Funjoy Technology Limited',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100250.png',
    gamePrivacyLink: 'https://ftads.net/privacy',
    gameTermsLink: 'https://ftads.net/terms'
  },
  100254: {
    appId: 100254,
    appStoreGameName: 'Merger Solitaire',
    developerName: 'FUNJOY',
    gameLogoLink: 'https://adsres.ftstats.com/web/guanwang/images/deleteAccount/100254.png',
  },
  100256: {
    appId: 100256,
    appStoreGameName: 'Dream Manor',
    developerName: 'FUNJOY',
    gameLogoLink: '',
  },
  100258: {
    appId: 100258,
    appStoreGameName: 'Nut Master',
    developerName: 'FUNJOY',
    gameLogoLink: '',
  },
  100260: {
    appId: 100260,
    appStoreGameName: 'Match 3D',
    developerName: 'FUNJOY',
    gameLogoLink: '',
  },
  100262: {
    appId: 100262,
    appStoreGameName: 'Block',
    developerName: 'FUNJOY',
    gameLogoLink: '',
  },
}



// WEBPACK FOOTER //
// ./src/components/pages/deleteAccount/gamesList.js